import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: () => import( /* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/news/list/:page',
    name: 'News',
    component: () => import( /* webpackChunkName: "new" */ '../views/News.vue')
  },
  {
    path: '/news/article/:id',
    name: 'NewsPage',
    component: () => import( /* webpackChunkName: "new_page" */ '../views/NewsPage.vue')
  },
  {
    path: '/gallery/list',
    name: 'Gallery',
    component: () => import( /* webpackChunkName: "gallery" */ '../views/Gallery.vue')
  },
  {
    path: '/gallery/album/:id',
    name: 'GalleryPage',
    component: () => import( /* webpackChunkName: "gallery_page" */ '../views/GalleryPage.vue')
  }
]

const router = new VueRouter({
  routes,
  mode: 'history',
  base: "/"
})

export default router